import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logService } from '../api/log.service';

export const MovementVersionDialog = ({
  open,
  onClose,
  versionId
}: {
  open: boolean;
  onClose: () => void;
  versionId: number;
}) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.versions.detail';
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    if (!open) return;

    logService.get(`/${versionId}/`).then((res) => {
      if (res.full_object) {
        const newRows = Object.entries(res.full_object).map(([field, value], id) => {
          const displayValue =
            typeof value === 'object' && value !== null ? JSON.stringify(value) : value;

          return {
            id,
            field: t(`pages.versions.entities.${res.model_name}.${field}` as any),
            value: displayValue
          };
        });

        setRows(newRows);
      }
    });
  }, [open, versionId]);

  const columns: GridColDef[] = [
    {
      field: 'field',
      headerName: t(`global.field`),
      flex: 1
    },
    {
      field: 'value',
      headerName: t(`global.value`),
      flex: 2
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>
        {t(`${translationPrefix}.title`)} {versionId}
      </DialogTitle>
      <DialogContent sx={{ height: '70vh', minHeight: 360 }}>
        <DataGridPremium
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          disableColumnMenu
          getRowHeight={() => 'auto'}
          getEstimatedRowHeight={() => 56}
          sx={{
            height: '100%',
            '& .MuiDataGrid-cell': {
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.35,
              py: 1
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MovementVersionDialog;
